import { Badge } from 'react-bootstrap'

function ActiveInActive({ text = '' }) {
  const safeText = text || ''
  return (
    <Badge pill bg={safeText === 'active' ? 'success' : 'secondary'}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function ReceiveBill({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'secondary'

  switch (safeText) {
    case 'To Receive':
      bgColor = 'primary'
      break
    case 'To Receive and Bill':
    case 'To Bill':
    case 'Draft':
      bgColor = 'secondary'
      break
    case 'Completed':
      bgColor = 'success'
      break
    default:
      bgColor = 'secondary'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function BadgeStatusSj({ text = '', bgColor = '' }) {
  const safeText = text || ''
  return (
    <Badge pill bg={bgColor}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function BadgeStatusInbound({ text = '', type = '' }) {
  const safeText = text || ''
  let bgColor = 'success'
  const status = safeText.toLowerCase()

  switch (status) {
    case 'done':
    case 'complete':
    case 'finished':
    case 'finish':
    case 'submit':
    case 'match':
    case 'active':
      bgColor = 'success'
      break
    case 'recheck':
    case 'waiting om':
    case 'revised':
    case 'done repack':
    case 'paletting':
    case 'confirmation':
      bgColor = 'warning'
      break
    case 'waiting':
    case 'waiting pnp':
    case 'waiting rnr':
      bgColor = 'secondary'
      break
    case 'incomplete':
    case 'closed':
    case 'not match':
    case 'not_match':
    case 'inactive':
    case 'problem':
    case 'canceled':
      bgColor = 'danger'
      break
    case 'unassigned':
      bgColor = 'dark'
      break
    case 'ongoing':
    case 'on going':
    case 'receiving progress':
    case 'put away':
    case 'repacking':
    case 'placing':
    case 'rnr':
    case 'pnp':
    case 'pnp picking':
    case 'confirmed':
      bgColor = 'primary'
      break
    default:
      if (type === 'BadgeStatusPrList') bgColor = 'primary'
      else if (type === 'BadgeStatusPrListInbounds') bgColor = 'danger'
      else bgColor = 'success'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.replaceAll('_', ' ').toUpperCase()}
    </Badge>
  )
}

function BadgeStatusPrList({ text = '' }) {
  return <BadgeStatusInbound text={text} type="BadgeStatusPrList" />
}

function BadgeStatusCOA({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'primary'

  switch (safeText) {
    case 'done':
    case 'match':
    case 'active':
      bgColor = 'success'
      break
    case 'unchecked':
      bgColor = 'secondary'
      break
    case 'not match':
    case 'not_match':
    case 'inactive':
      bgColor = 'danger'
      break
    default:
      bgColor = 'primary'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.replaceAll('_', ' ').toUpperCase()}
    </Badge>
  )
}

function BadgeStatusPrLists({ text = '' }) {
  return <BadgeStatusInbound text={text} type="BadgeStatusPrLists" />
}

function BadgeStatusSjList({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'success'

  switch (safeText) {
    case 'unassigned':
      bgColor = 'dark'
      break
    case 'waiting rnr':
    case 'waiting pnp':
      bgColor = 'secondary'
      break
    case 'rnr':
    case 'pnp':
      bgColor = 'primary'
      break
    case 'request pnp':
      bgColor = 'warning'
      break
    default:
      bgColor = 'success'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function OutboundHistory({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'danger'

  switch (safeText) {
    case 'success':
      bgColor = 'success'
      break

    default:
      bgColor = 'danger'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function BadgeStatusPrListInbounds({ text = '' }) {
  return <BadgeStatusInbound text={text} type="BadgeStatusPrListInbounds" />
}

function BadgeStatusOutboundPlan({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'success'

  switch (safeText) {
    case 'unassigned':
      bgColor = 'dark'
      break
    case 'waiting_pnp':
    case 'waiting_rnr':
    case 'request_loading':
      bgColor = 'secondary'
      break
    case 'pnp_picking':
    case 'rnr_checking':
    case 'loading':
    case 'on_delivery':
      bgColor = 'primary'
      break
    case 'waiting_om':
    case 'finish_loading':
      bgColor = 'warning'
      break
    case 'done':
      bgColor = 'success'
      break
    default:
      bgColor = 'danger'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.replaceAll(/_/g, ' ').toUpperCase()}
    </Badge>
  )
}

function WorkOrderStatus({ text = '' }) {
  const safeText = text || ''
  let bgColor = ''

  switch (safeText) {
    case 'waiting':
      bgColor = 'secondary'
      break
    case 'confirmation':
      bgColor = 'warning'
      break
    case 'confirmed':
      bgColor = 'primary'
      break
    case 'done':
      bgColor = 'success'
      break
    case 'problem':
      bgColor = 'danger'
      break
    case 'canceled':
      bgColor = 'danger'
      break
    default:
      bgColor = 'secondary'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.toUpperCase()}
    </Badge>
  )
}

function BadgeStatusStockTake({ text = '' }) {
  const safeText = text || ''
  let bgColor = 'success'

  switch (safeText) {
    case 'waiting':
      bgColor = 'secondary'
      break
    case 'on_going':
    case 'ongoing':
      bgColor = 'primary'
      break
    case 'recheck':
      bgColor = 'warning'
      break
    default:
      bgColor = 'success'
      break
  }

  return (
    <Badge pill bg={bgColor}>
      {safeText.replaceAll('_', ' ').toUpperCase()}
    </Badge>
  )
}

export {
  ActiveInActive,
  BadgeStatusCOA,
  BadgeStatusOutboundPlan,
  BadgeStatusPrList,
  BadgeStatusPrListInbounds,
  BadgeStatusPrLists,
  BadgeStatusSj,
  BadgeStatusSjList,
  OutboundHistory,
  ReceiveBill,
  WorkOrderStatus,
  BadgeStatusStockTake,
  BadgeStatusInbound
}
